import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AlertTriangle, Monitor, Shield, Users } from 'lucide-react';

const stats = [
  { key: 'failed_logins', path: 'count_24h', label: 'Failed Logins (24h)', icon: AlertTriangle, color: 'text-red-500' },
  { key: 'active_sessions', path: 'total', label: 'Active Sessions', icon: Monitor, color: 'text-blue-500' },
  { key: 'security_flags', path: 'unresolved', label: 'Security Flags', icon: Shield, color: 'text-amber-500' },
  { key: 'two_factor_auth', path: 'percentage', label: '2FA Adoption', icon: Users, color: 'text-emerald-500', suffix: '%' },
];

export const SecurityStatCards = ({ data }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    {stats.map(({ key, path, label, icon: Icon, color, suffix }) => (
      <Card key={key}>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-600">{label}</p>
              <p className="text-3xl font-bold text-slate-900">{data?.[key]?.[path] || 0}{suffix || ''}</p>
            </div>
            <Icon className={`w-8 h-8 ${color}`} />
          </div>
        </CardContent>
      </Card>
    ))}
  </div>
);
